export const approvalTimelineLabels: Record<string, string> = {
  approval_started: "Запущено согласование",
  approval_level_opened: "Открыт уровень",
  approval_decision: "Решение по согласованию",
  approval_returned: "Согласование возвращено на доработку",
  approval_resubmitted: "Согласование отправлено повторно",
  approval_approved: "Документ согласован",
  approval_rejected: "Согласование отклонено",
  approval_withdrawn: "Согласование отозвано",
  approval_task_redirected: "Задание согласования перенаправлено",
  assignment_redirected: "Назначение перенаправлено",
};
function personName(value: unknown): string | null {
  if (typeof value !== "object" || value === null || !("display_name" in value))
    return null;
  return typeof value.display_name === "string" ? value.display_name : null;
}
export function approvalTimelineTitle(
  type: string,
  payload: Record<string, unknown>,
): string | null {
  if (!(type in approvalTimelineLabels)) return null;
  if (type === "approval_level_opened")
    return `Открыт уровень ${typeof payload.position === "number" ? payload.position : ""}`.trim();
  if (type === "approval_decision") {
    const result = {
      approve: "Согласовано",
      return: "Возвращено на доработку",
      reject: "Отклонено",
    };
    const decision =
      typeof payload.decision === "string" && payload.decision in result
        ? result[payload.decision as keyof typeof result]
        : "Решение";
    const original = personName(payload.on_behalf_of);
    return `Решение по согласованию: ${decision}${original ? ` вместо ${original}` : ""}`;
  }
  if (type === "assignment_redirected")
    return `Назначение передано ${personName(payload.recipient) ?? "сотруднику"} вместо ${personName(payload.redirected_from) ?? "отсутствующего сотрудника"}`;
  if (type === "approval_task_redirected")
    return `Задание согласования ${payload.routed_to_id === null ? "возвращено" : "передано"} ${personName(payload.recipient) ?? "сотруднику"}${payload.routed_to_id === null ? "" : " на время замещения"}`;
  return approvalTimelineLabels[type]!;
}
